/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
    const { colors, borderRadius, spacing } = useTheme();
    return {
        select: css`
            font-size: ${spacing.s};
            font-family: 'FS Dillon';
            height: 3rem;
            padding: 0.75rem 1rem;
            display: block;
            border-radius: ${borderRadius.m};
            border: 2px solid ${colors.border_blue};
            background: ${colors.white};
            text-align: center;
            width: 100%;
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            padding-left: 1.5rem; /* room for left icon */

            &:hover,
            &:focus {
                outline: none;
                border-color: ${colors.navy};
                background-color: ${colors.pale_blue};
            }

            /* Strict Keyboard Only State */
            &.keyboard-focus:focus {
                outline: 2px solid ${colors.skip_yellow};
                border: 2px solid ${colors.border_black};
                background-color: ${ colors.pale_blue};
            }
        `,
        /* wrapper for select to position icons */
        wrapper: css`
            position: relative;
            width: 100%;
        `,
        /* dropdown list (if using custom list) - kept for backwards compatibility */
        dropdownDistanceList: css`
            position: absolute;
            width: 100%;
            margin-top: 0.5rem;
            padding: 0.5rem;
            z-index: 1;
            background: ${colors.white};
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
            border-radius: ${borderRadius.m};
            /* fixed height and scrollable */
            height: 14.375rem;
            overflow-y: auto;
            scroll-behavior: smooth;
            box-sizing: border-box;
        `,
        distanceOptionValues: isActive => css`
            display: flex;
            gap: 0.75rem;
            align-items: center;
            padding: 0.5rem;
            cursor: pointer;
            border-radius: 0.25rem;
            transition: background-color 120ms ease, font-weight 120ms ease;
            background-color: ${isActive ? colors.pale_blue : 'transparent'};
            font-weight: ${isActive ? 700 : 400};

            &:hover {
                background-color: ${colors.pale_blue};
                font-weight: 700;
                color: #1B1B1A !important;
            }

            svg path,
            svg circle {
                stroke: ${isActive ? colors.surfaceBlue : colors.buttonRed} !important;
                fill: ${isActive ? colors.surfaceBlue : colors.buttonRed} !important;
                transition: stroke 0.12s ease, fill 0.12s ease;
            }

            &:hover svg path,
            &:hover svg circle {
                stroke: ${colors.surfaceBlue} !important;
                fill: ${colors.surfaceBlue} !important;
            }
        `,
        distanceListValue: css`
            display: inline-block;
            font-family: 'FS Dillon';
            font-size: 1rem;
            line-height: 1.25rem;
            letter-spacing: 2%;
            box-sizing: border-box;
            /* Keep text color stable so only the icon changes color */
            color: ${colors.divider_gray} !important;
            &:focus {
                outline: none;
                width:100%;
            }
            &:focus-visible {
                background-color: ${colors.skip_yellow};
                /* underline that matches the text width only */
                border-bottom: 2px solid ${colors.border_black};
                text-decoration: underline;
                font-weight: 700;
                color:#1B1B1A !important;
            } 
        `,
        iconWrapper: css`
            display: inline-flex;
            align-items: center;
            /* inherit color from parent so list item hover/active controls icon color */
            color: inherit;
            /* ensure SVGs inside use currentColor so we can change icon color via CSS */
            svg, path, circle, rect {
                fill: currentColor !important;
                stroke: currentColor !important;
            }
        `,
        selectCaret: css`
            position: absolute;
            right: 1.75rem;
            top: 36%;
            width: 0;
            height: 0;
            cursor: pointer;
        `,
        fullWidth: css`
            width: 100%;
        `,
        valueText: css`
            display: inline-block;
            color: ${colors.placeholder_black2};
        `,
        valueNumber: css`
            font-weight: 700;
            display: inline-block;
            color: ${colors.placeholder_black2};
        `,
    };
};